export default __webpack_public_path__ + "assets/images/7bb3f22853818c478a939aa8362d4c77.svg";